import { useContext, useState } from "react";
import { LoaderCard } from "../../../common/Loader";
import NepalDistrict from "../../../common/Maps/NepalDistrict";
import NepalRegion from "../../../common/Maps/NepalRegion";
import NepalProvince from "../../../common/Maps/NepalProvince";
import { ASSET_HOST_BASE_URL, independentParty, otherParty } from "../../../../config";
import { getDistrictSummary, getIndependentSymbol, getProvinceSummary, translate, translateNumber } from "../../../../helper";
import LangContext from "../../../../contexts/LangContext";

const Nepal = (props) => {
  const { lang } = useContext(LangContext);
  const [mapView, setMapView] = useState("view2");

  let mapManaulSelected = false;

  // setInterval(() => {
  //   setMapView(mapView === "view2" ? "view1" : "view2");
  // }, 15000);

  const showMapLegend = (pid, did, legendType) => {
    let provId;
    let legendInfo = { result: [] };
    if (props.tab === "federal") {
      props.data.provinces.forEach((pData) => {
        pData.districts.forEach((dData) => {
          if (dData.id === did) {
            legendInfo.province = pData.id;
            const { win, lead } = getDistrictSummary(dData);
            win.forEach((data, i) => {
              const leadData = lead.find((l) => l.party === data.party);
              const result = { party: data.party, win: data.win, lead: leadData ? leadData.lead : 0 };
              legendInfo.result.push(result);
            });
          }
        });
      });
    } else {
      provId = parseInt(pid);

      props.data.provinces.forEach((pData) => {
        if (pData.id === provId) {
          let summary;
          if (legendType === "district") {
            summary = getDistrictSummary(pData.districts.find((d) => d.id === did));
          } else {
            summary = getProvinceSummary(pData);
          }

          const { win, lead } = summary;

          win.forEach((data, i) => {
            const leadData = lead.find((l) => l.party === data.party);
            const result = { party: data.party, win: data.win, lead: leadData ? leadData.lead : 0 };
            legendInfo.result.push(result);
          });
        }
      });
    }

    const districts = [];

    props.provinces.forEach((prov) => {
      prov.districts.forEach((dist) => {
        districts.push(dist);
      });
    });

    document.querySelector("#map-legend-title-span").innerHTML = translate(props.tab === "federal" ? "district" : "province", lang) + " - ";
    document.querySelector("#map-legend-title-link").innerHTML = !did ? props.provinces.find((prov) => prov.id === provId)["name_" + lang] : districts.find((dist) => dist.id === did)["name_" + lang];
    document.querySelector("#map-legend-title-link").setAttribute("href", "/result/" + (legendInfo.province ? legendInfo.province + "/" + did : pid) + "?type=" + props.tab + "&lang=" + lang);
    document.querySelector("#map-legend-table-head-row").innerHTML = `<th></th><th>${translate("win", lang)}</th><th>${translate("lead", lang)}</th>`;

    const result_template = '<tr><td><Link to="#party_link#"><img src="#party_symbol#" width="16px" height="16px"> #party_name#</Link></td><td>#win#</td><td>#lead#</td></tr>';

    let totalRow = "";
    legendInfo.result
      .filter((r) => r.win > 0 || r.lead > 0)
      .forEach((result, i) => {
        let party = "";
        if (result.party.match(/I+\d/)) {
          result.party = "I";
          party = independentParty;
        } else if (result.party === "O") {
          party = otherParty;
        }
        const party_link = "/candidates" + (result.party === "I" || result.party === "O" ? "" : "/" + result.party);
        party = props.parties.find((par) => par.code === result.party) || otherParty;

        let row = result_template;
        row = row.replace("#party_name#", party["short_name_" + lang] || party["name_" + lang]);
        row = row.replace("#party_symbol#", ASSET_HOST_BASE_URL + "/images/parties/" + party.code.toUpperCase() + ".png");
        row = row.replace("#party_link#", party_link);
        row = row.replace("#win#", translateNumber(result.win, lang));
        row = row.replace("#lead#", translateNumber(result.lead, lang));
        totalRow += row;
      });

    document.querySelector("#sh-map-legend table tbody").innerHTML = totalRow;
    document.querySelector("#sh-map-legend").style.display = "block";
    document.querySelector("#sh-map-legend").style.opacity = "1";
  };

  const handleMouseMove = (el) => {
    /*const containerBox = document.querySelector(".sh-nepal-district").getBoundingClientRect();
        const legendBox = document.querySelector("#sh-map-legend").getBoundingClientRect();
        const xLimit = containerBox.x + containerBox.width;
        const xLegend = legendBox.x + legendBox.width;
        const minxLimit = document.querySelectorAll(".sh-radio-choice .form-check")[1].getBoundingClientRect();
    
        document.getElementById("sh-map-legend").style.top = el.pageY - 800 + "px";
        document.getElementById("sh-map-legend").style.left = el.pageX - 200 + "px";
    
        if (xLegend >= xLimit || el.pageX - 200 + 300 > containerBox.width) {
          document.getElementById("sh-map-legend").style.left = containerBox.width - legendBox.width + "px";
        } else if (legendBox.x <= minxLimit.x + minxLimit.width || el.pageX < minxLimit.x + minxLimit.width) {
          document.getElementById("sh-map-legend").style.left = minxLimit.x + "px";
        }
    
        if (legendBox.y >= containerBox.y) {
          // document.getElementById("sh-map-legend").style.top = containerBox.y - 300 + "px";
        }*/
  };

  const showMapLegendCandidate = (pid, did, rid, specialData) => {
    if (!pid && !did && !rid) {
      document.querySelector("#map-legend-title-span").innerHTML = translate("region", lang);
      document.querySelector("#map-legend-title-link").innerHTML = "";
      document.querySelector("#map-legend-table-head-row").innerHTML = `<th>${specialData}</th>`;
      document.querySelector("#sh-map-legend table tbody").innerHTML = "";
      return true;
    } else {
      const district = pid && props.data.provinces.find((pData) => pData.id === parseInt(pid)).districts.find((dData) => dData.id === did);

      const region = district.regions.find((rData) => rData.id === parseFloat(rid));

      document.querySelector("#map-legend-title-span").innerHTML = translate("region", lang) + " - ";
      document.querySelector("#map-legend-title-link").innerHTML = district["name_" + lang] + ": " + region["name_" + lang];
      document.querySelector("#map-legend-title-link").setAttribute("href", "/result/" + pid + "/" + did + "/" + parseFloat(rid).toFixed(0));
      document.querySelector("#map-legend-table-head-row").innerHTML = `<th>${translate("candidates", lang)}</th><th>${translate("vote", lang)}</th><th></th>`;
      const result_template = `<tr><td><Link to="#party_link#"><img src="#party_symbol#" width="16px" height="16px" alt="#party_alt#" onerror=this.src="${ASSET_HOST_BASE_URL + "/images/parties/O.png"}"> #candidate_name#</Link></td><td>#vote#</td><td style="vertical-align: middle"><img src="${ASSET_HOST_BASE_URL + "/images/circle_check_regular.svg"}" alt="elected" style="width: 15px; display: #elected#"></td></tr>`;

      let totalRow = "";
      let candidateList = JSON.parse(JSON.stringify(region.result));
      candidateList = candidateList.sort((a, b) => b.vote - a.vote);

      for (let i = 0; i < candidateList.length; i++) {
        const candidate = candidateList[i];

        const party_link = "/candidates" + (candidate.party === "O" ? "" : "/" + candidate.party);
        const party = props.parties.find((par) => par.code === candidate.party) || otherParty;
        let symbol = party.code.toUpperCase();
        if (symbol === "O" || symbol.match(/I+\d/)) {
          symbol = getIndependentSymbol(did, rid, candidate.name_en);
        }
        let row = result_template;
        row = row.replace("#candidate_name#", candidate["name_" + lang]);
        row = row.replace("#party_symbol#", ASSET_HOST_BASE_URL + "/images/parties/" + symbol + ".png");
        row = row.replace("#party_alt#", party.code.toUpperCase());
        row = row.replace("#party_link#", party_link);
        row = row.replace("#vote#", translateNumber(candidate.vote, lang));
        row = row.replace("#elected#", candidate.elected ? "block" : "none");

        totalRow += row;
        if (i === 3) break;
      }

      document.querySelector("#sh-map-legend table tbody").innerHTML = totalRow;
      document.querySelector("#sh-map-legend").style.display = "block";
      document.querySelector("#sh-map-legend").style.opacity = "1";
    }
  };

  const handleLegendClick = (el) => {
    const pid = el.target.getAttribute("data-id").split("-")[2];
    props.handleSearch(pid, "province");
  };

  const handlePartyLegendClick = (el) => {
    const party = el.target.getAttribute("data-code");
    if (party) {
      window.location.href = window.location.origin + "/candidates/" + party + window.location.search;
    }
  };

  const handleLegendOnMouseOver = (el) => {
    const id = el.target.getAttribute("data-id");

    if (id) {
      document.querySelectorAll(".sh-map-fg").forEach((prov) => {
        if (prov.getAttribute("id").split("-")[1] === id.split("-")[2]) {
          prov.querySelectorAll("g path").forEach((dist) => {
            dist.setAttribute("opacity", 0.6);
          });
        } else {
          prov.querySelectorAll("g path").forEach((dist) => {
            dist.setAttribute("opacity", 1);
          });
        }
      });
    }
  };

  const handlePartyLegendOnMouseOver = (el) => {
    document.querySelectorAll("path").forEach((p) => {
      const party = el.target.getAttribute("data-code");
      if (p.getAttribute("dataparty") && p.getAttribute("dataparty") !== party) {
        p.setAttribute("fillOrig", p.getAttribute("fill"));
        p.setAttribute("fill", "#DDDDDD");
      }
    });
  };

  const handlePartyLegendOnMouseLeave = (el) => {
    document.querySelectorAll("path").forEach((p) => {
      if (p.getAttribute("dataparty") && p.getAttribute("fillOrig")) {
        p.setAttribute("fill", p.getAttribute("fillOrig"));
      }
    });
  };

  const handleChangeMap = (el) => {
    mapManaulSelected = true;
    setMapView(el.target.value);
  };

  // if (mapManaulSelected) {
  //   for (let i = 1; i < 1000; i++) {
  //     clearInterval(i);
  //   }
  // }

  return (
    <div className="container-fluid  card sh-card-map">
      {!props.fetched && <LoaderCard />}
      <div className="row" style={{ opacity: props.fetched ? "1" : 0.5 }}>
        <div className="col-md-12 sh-map">
          <div className="sh-map-legend d-none d-md-block" id="sh-map-legend">
            <h4>
              <span id="map-legend-title-span"></span>
              <a href="/result/" id="map-legend-title-link">
                ""
              </a>
            </h4>
            <table className="table">
              <thead>
                <tr id="map-legend-table-head-row"></tr>
              </thead>
              <tbody></tbody>
            </table>
          </div>

          <div className="sh-radio-choice mt-3">
            <div className="form-check">
              <input className="form-check-input" type="radio" name="view1" id="view1" value="view1" checked={mapView === "view1"} onChange={handleChangeMap} />
              <label className="form-check-label" htmlFor="view1">
                {translate("district_view", lang)}
              </label>
            </div>
            <div className="form-check">
              <input className="form-check-input" type="radio" name="view2" id="view2" value="view2" checked={mapView === "view2"} onChange={handleChangeMap} />
              <label className="form-check-label" htmlFor="view2">
                {translate("region_view", lang)}
              </label>
            </div>
          </div>

          {mapView === "view1" && (
            <div className="sh-legend-province d-none d-md-block">
              <ul>
                {props.provinces.map((p, i) => (
                  <li className="box" key={i}>
                    <span className="sh-province-color" style={{ background: p.color }} data-id={"legend-pradesh-" + (i + 1)} onMouseOver={handleLegendOnMouseOver} onClick={handleLegendClick}></span>
                    <label> {p["short_name_" + lang] || p["name_" + lang]}</label>
                  </li>
                ))}
              </ul>
            </div>
          )}

          {mapView === "view2" && (
            <div className="sh-legend-party d-none d-md-block">
              <ul>
                {props.parties
                  .filter((p, i) => i > 0 && i < 8)
                  .map((party, i) => (
                    <li className="box" key={i}>
                      <span className="sh-province-color" style={{ background: party.color }} data-code={party.code} onMouseOver={handlePartyLegendOnMouseOver} onMouseLeave={handlePartyLegendOnMouseLeave} onClick={handlePartyLegendClick}></span>
                      <label> {party["short_name_" + lang] || party["name_" + lang]}</label>
                    </li>
                  ))}
                {props.parties
                  .filter((p, i) => i === 0)
                  .map((party, i) => (
                    <li className="box" key={i}>
                      <span className="sh-province-color" style={{ background: party.color }} data-code={party.code} onMouseOver={handlePartyLegendOnMouseOver} onMouseLeave={handlePartyLegendOnMouseLeave} onClick={handlePartyLegendClick}></span>
                      <label> {party["short_name_" + lang] || party["name_" + lang]}</label>
                    </li>
                  ))}
              </ul>
            </div>
          )}
          {mapView === "view1" ? props.tab === "federal" ? <NepalDistrict data={props.provinces} showMapLegend={showMapLegend} handleMouseMove={handleMouseMove} /> : <NepalProvince data={props.provinces} showMapLegend={showMapLegend} handleMouseMove={handleMouseMove} /> : <NepalRegion tab={props.tab} data={props.provinces} result={props.data} parties={props.parties} showMapLegendCandidate={showMapLegendCandidate} showMapLegend={showMapLegend} handleMouseMove={handleMouseMove} />}
        </div>
      </div>
    </div>
  );
};

export default Nepal;
